import { useQueryClient } from "@tanstack/react-query";
import { type ReactNode, useEffect, useState } from "react";

import type { ConnectionState } from "./ConnectionState";
import { connectRealtime } from "./connectRealtime";
import { RealtimeContext } from "./RealtimeContext";
import { realtimeHandlers } from "./realtimeHandlers";

type RealtimeProviderProps = {
  children: ReactNode;
};

// Одно соединение Centrifugo на вкладку. Гость получает 401 на токен —
// соединение остаётся `disconnected` без повторов. Вход через Steam заканчивается
// перезагрузкой страницы, после неё провайдер подключается заново.
export const RealtimeProvider = ({ children }: RealtimeProviderProps) => {
  const queryClient = useQueryClient();
  const [state, setState] = useState<ConnectionState>("connecting");

  useEffect(
    () => connectRealtime({ queryClient, registry: realtimeHandlers, onStateChange: setState }),
    [queryClient],
  );

  return <RealtimeContext value={state}>{children}</RealtimeContext>;
};
